import React, { useState, useEffect, useMemo, useCallback } from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import DocumentForm from './DocumentForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { useSelector } from 'react-redux';
import { FormCustom, Input, TextArea } from '../../Components/Form/Form'

const Document = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})

    const [dataFilter, setDataFilter] = useState({
        p_date_start: Helpers.date.get({ format: '%Y-%m-%d', addDays: -1 }),
        p_date_end: Helpers.date.get({ format: '%Y-%m-%d' }),
    })

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.document.get_document(dataFilter).then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
                .finally(() => {
                    setIsProccesing(false)
                    setReload(false)
                })
        }
    }, [reload, dataFilter])

    const permissions = useSelector(store => store.session.permissions)
    const actionsModule = Helpers.getActions({ permissions, module: 'documentos' })

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idDocument) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idDocument, view = 0, verified = 0, addDetails = 0 } = $this.dataset

        Controllers.document.get_document_id({ p_id_document: idDocument }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idDocument}`)
            setDataUpdated({ data: res.data, viewSubmit: parseInt(view) !== 1, verified, addDetails })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
            .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idDocument, nameDocument } = e.currentTarget.dataset
        setDataDeleted({
            p_id_document: idDocument,
            p_name_document: nameDocument,
            p_observation_anulado: ''
        })
        setShowConfirmDelete(true)
        setDataAlert({
            icon: 'delete',
            title: 'anular el documento',
            confirmText: '¡Sí, anular!',
            cancelText: '¡No, cancelar!',
            onCancel: handleHideModalDelete,
            onConfirm: _ => {
                if (document.querySelector('#observation_anulado').value === '') {
                    Helpers.toast.construct({ response: 'warning', message: 'Por favor, ingresar motivo', toast })
                    return
                }
                console.log('idDocument', {
                    p_id_document: idDocument,
                    p_name_document: nameDocument,
                    p_observation_anulado: document.querySelector('#observation_anulado').value
                })

                setLoadSubmitDelete(true)
                Controllers.document.document_delete({
                    p_id_document: idDocument,
                    p_name_document: nameDocument,
                    p_observation_anulado: document.querySelector('#observation_anulado').value
                }).then(res => {
                    Helpers.toast.construct({ ...res, toast })
                    if (res.response === 'success') {
                        setShowConfirmDelete(false)
                        setDataDeleted({})
                    }
                }).catch(req => Helpers.promise.catch({ req, toast }))
                    .finally(() => {
                        setReload(true)
                        setLoadSubmitDelete(false)
                    })
            },
            content: _ => <>
                <TextArea
                    classNameParent="col-12"
                    icon="far fa-comment-alt"
                    placeholder="Motivo"
                    text="Motivo"
                    id="observation_anulado"
                    required
                    rows={4}
                />
            </>
        })
    }

    const handleShowModalApprove = e => {
        let { idDocument, nameDocument, idTypeDocument, qtyProduct, anulado } = e.currentTarget.dataset

        if (parseInt(idTypeDocument) === 6) {
            if (parseInt(anulado) === 9) {
                setDataDeleted({
                    p_id_document: idDocument,
                    p_name_document: nameDocument
                })
                setShowConfirmDelete(true)
                setDataAlert({
                    icon: 'approve',
                    title: 'Aprobar Recepción',
                    confirmText: '¡Sí, aprobar!',
                    cancelText: '¡No, cancelar!',
                    onCancel: handleHideModalDelete,
                    onConfirm: _ => {
                        setLoadSubmitDelete(true)
                        Controllers.document.document_anulado_change({
                            p_id_document: idDocument,
                            p_anulado: 3,
                        }).then(_ => {
                            Helpers.toast.construct({ response: 'success', message: 'Producción aprobado', toast })
                            setShowConfirmDelete(false)
                            setDataDeleted({})
                        }).catch(req => Helpers.promise.catch({ req, toast }))
                            .finally(() => {
                                setReload(true)
                                setLoadSubmitDelete(false)
                            })
                    },
                })
            } else {
                setDataDeleted({
                    p_id_document: idDocument,
                    p_name_document: nameDocument
                })
                setShowConfirmDelete(true)
                setDataAlert({
                    icon: 'approve',
                    title: 'aprobar producción',
                    confirmText: '¡Sí, aprobar!',
                    cancelText: '¡No, cancelar!',
                    onCancel: handleHideModalDelete,
                    onConfirm: _ => {
                        if (document.querySelector('#txt_date_expiration').value === '') {
                            Helpers.toast.construct({ response: 'warning', message: 'Ingresar fecha de expiración', toast })
                            return false
                        }

                        if (document.querySelector('#txt_lote').value === '') {
                            Helpers.toast.construct({ response: 'warning', message: 'Ingresar lote', toast })
                            return false
                        }

                        if (document.querySelector('#txt_lote').value === '') {
                            Helpers.toast.construct({ response: 'warning', message: 'Ingresar lote', toast })
                            return false
                        }

                        if (document.getElementById('txt_change_qty').checked) {
                            if (document.getElementById('txt_qty_production').value === '') {
                                Helpers.toast.construct({ response: 'warning', message: 'Ingresar cantidad', toast })
                                return false
                            }

                            if (parseInt(document.getElementById('txt_qty_production').value) > parseInt(qtyProduct)) {
                                Helpers.toast.construct({ response: 'warning', message: 'La cantidad no puede ser mayor a la cantidad de productos', toast })
                                return false
                            }
                        }

                        setLoadSubmitDelete(true)
                        Controllers.document.document_anulado_change({
                            p_id_document: idDocument,
                            p_anulado: 9,
                            p_date_expiration: document.getElementById('txt_date_expiration').value,
                            p_lote: document.getElementById('txt_lote').value,
                            p_qty_product: document.getElementById('txt_change_qty').checked ? document.getElementById('txt_qty_production').value : 0,
                            p_change_qty: document.getElementById('txt_change_qty').checked ? 1 : 0,
                        }).then(_ => {
                            Helpers.toast.construct({ response: 'success', message: 'Producción aprobado', toast })
                            setShowConfirmDelete(false)
                            setDataDeleted({})
                        }).catch(req => Helpers.promise.catch({ req, toast }))
                            .finally(() => {
                                setReload(true)
                                setLoadSubmitDelete(false)
                            })
                    },
                    content: _ => <>
                        <Input
                            text="Fecha Expiración"
                            type="date"
                            classNameParent="w-100 mb-2"
                            id="txt_date_expiration"
                            defaultValue={Helpers.date.get({ format: '%Y-%m-%d' })}
                        />
                        <Input
                            text="Lote"
                            classNameParent="w-100 mb-2"
                            id="txt_lote"
                            maxLength="50"
                        />
                        <div className='mb-2 text-left'>Cantidad Producida: <strong>{qtyProduct}</strong></div>
                        <div className='d-flex justify-content-start'>
                            <label className='align-self-center'>¿Cambiar Cantidad Producida?</label>
                            <Input
                                type="checkbox"
                                classNameParent="mb-2 align-self-center ml-2"
                                id="txt_change_qty"
                                maxLength="50"
                                onChange={e => {
                                    if (e.currentTarget.checked) {
                                        document.getElementById('txt_qty_production_content').classList.remove('d-none')
                                    } else {
                                        document.getElementById('txt_qty_production_content').classList.add('d-none')
                                    }
                                }}
                            />
                        </div>
                        <div id="txt_qty_production_content" className='d-none'>
                            <Input
                                type="number"
                                text="Cantidad Producida"
                                classNameParent="w-100 mb-2"
                                id="txt_qty_production"
                                min="1"
                                step="1"
                            />
                        </div>
                    </>
                })
            }
        } else {
            setDataDeleted({
                p_id_document: idDocument,
                p_name_document: nameDocument
            })
            setShowConfirmDelete(true)
            setDataAlert({
                icon: 'approve',
                title: 'aprobar la solicitud de producción',
                confirmText: '¡Sí, aprobar!',
                cancelText: '¡No, cancelar!',
                onCancel: handleHideModalDelete,
                onConfirm: _ => {
                    if (document.querySelector('#txt_date_production').value === '') {
                        Helpers.toast.construct({ response: 'warning', message: 'Ingresar fecha estimada de producción', toast })
                        return false
                    }

                    setLoadSubmitDelete(true)
                    Controllers.document.document_anulado_change({
                        p_id_document: idDocument,
                        p_anulado: 6,
                        p_date_production: document.querySelector('#txt_date_production').value
                    }).then(_ => {
                        Helpers.toast.construct({ response: 'success', message: 'Solicitud aprobada', toast })
                        setShowConfirmDelete(false)
                        setDataDeleted({})
                    }).catch(req => Helpers.promise.catch({ req, toast }))
                        .finally(() => {
                            setReload(true)
                            setLoadSubmitDelete(false)
                        })
                },
                content: _ => <>
                    <Input
                        text="Fecha estimada de producción"
                        type="date"
                        classNameParent="w-100"
                        id="txt_date_production"
                    />
                </>
            })
        }
    }

    const handleMateriaPrima = e => {
        let { idDocument, nameDocument } = e.currentTarget.dataset

        setDataDeleted({
            p_id_document: idDocument,
            p_name_document: nameDocument
        })
        setShowConfirmDelete(true)
        setDataAlert({
            icon: 'approve',
            title: 'Liberar Materia Prima',
            confirmText: '¡Sí, aprobar!',
            cancelText: '¡No, cancelar!',
            onCancel: handleHideModalDelete,
            onConfirm: _ => {
                if (document.querySelector('#txt_observacion_materia_prima').value === '') {
                    Helpers.toast.construct({ response: 'warning', message: 'Ingresar observación', toast })
                    return false
                }

                setLoadSubmitDelete(true)
                Controllers.document.document_liberar_materia_prima({
                    p_id_document: idDocument,
                    p_observation_materia_prima: document.querySelector('#txt_observacion_materia_prima').value
                }).then(res => {
                    if (res.response === 'success') {
                        Helpers.toast.construct({ response: 'success', message: 'Solicitud aprobada', toast })
                        setShowConfirmDelete(false)
                        setDataDeleted({})
                    } else {
                        Helpers.toast.construct({ response: 'warning', message: res.message, toast })
                        let txt_details_materia_prima = '';
                        res.data.forEach(item => {
                            txt_details_materia_prima += `<div class="mb-2">
                                <div>Producto: ${item.key_product} - ${item.name_product}</div>
                                <div>Cantidad Solicitada: ${item.qty_requested}</div>
                                <div>Cantidad Existente: ${item.qty_available}</div>
                            </div>`
                        })
                        document.querySelector('#txt_details_materia_prima').innerHTML = txt_details_materia_prima
                    }
                }).catch(req => Helpers.promise.catch({ req, toast }))
                    .finally(() => {
                        setReload(true)
                        setLoadSubmitDelete(false)
                    })
            },
            content: _ => <>
                <TextArea
                    text="Observación"
                    classNameParent="w-100"
                    id="txt_observacion_materia_prima"
                />
                <div id="txt_details_materia_prima" className=' mt-2'></div>
            </>
        })
    }

    /* const handleShowModalSendBranchOffice = e => {
        let { idDocument, nameDocument } = e.currentTarget.dataset
        setDataDeleted({
            p_id_document: idDocument,
            p_name_document: nameDocument
        })
        setShowConfirmDelete(true)
        setDataAlert({
            icon: 'approve',
            title: 'enviar la producción a la sucursal',
            confirmText: '¡Sí, enviar!',
            cancelText: '¡No, cancelar!',
            onCancel: handleHideModalDelete,
            onConfirm: _ => {
                setLoadSubmitDelete(true)
                Controllers.document.document_anulado_change({
                    p_id_document: idDocument,
                    p_anulado: 7
                }).then(_ => {
                    Helpers.toast.construct({ response: 'success', message: 'Producción enviada a sucursal', toast })
                    setShowConfirmDelete(false)
                    setDataDeleted({})
                }).catch(req => Helpers.promise.catch({ req, toast }))
                    .finally(() => {
                        setReload(true)
                        setLoadSubmitDelete(false)
                    })
            }
        })
    } */

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_document', text: 'ID', align: 'center' },
                { name: 'key_branch_office', text: 'Sucursal', align: 'center' },
                { name: 'name_branch_office', text: 'Nombre', align: 'center' },
                /* { name: 'number_invoice_doc', text: 'Folio', align: 'center' }, */
                { name: 'name_document', text: 'Tipo', align: 'center' },
                { name: 'observation_doc', text: 'Comentarios' },
                { name: 'date_doc', text: 'Fecha', align: 'center' },
                { name: 'code_period', text: 'Periodo', align: 'center' },
                { name: 'user_created', text: 'Usuario', align: 'center' },
                {
                    name: 'anulado', text: 'Estado', align: 'center', render: r => {
                        return <div className={'text-center font-weight-bold text-' + (r.anulado_color)}>
                            {r.anulado_text}
                        </div>
                    }
                },
                {
                    name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
                        return <div>
                            {actionsModule?.view ? <Button variant={actionsModule?.view.color_action} className="mr-1" size="xs" data-view={1} data-id-document={u.id_document} data-name-document={u.name_document} onClick={handleGet}>
                                <i className={actionsModule?.view.icon}></i>
                            </Button> : ''}
                            {actionsModule?.approve_production && ((parseInt(u.anulado) === 2 && parseInt(u.id_type_document) === 3) || (parseInt(u.anulado) === 7 && parseInt(u.id_type_document) === 4)) ? <Button variant={actionsModule?.confirm.color_action} className="mr-1" size="xs" data-verified={1} data-view={1} data-id-document={u.id_document} data-name-document={u.name_document} onClick={handleGet}>
                                <i className={actionsModule?.confirm.icon}></i>
                            </Button> : ''}
                            {actionsModule?.approve_production && (parseInt(u.id_type_document) === 4) && parseInt(u.anulado) === 2 ? <Button variant={actionsModule?.approve_production.color_action} className="mr-1" size="xs" data-id-document={u.id_document} data-name-document={u.name_document} data-id-type-document={u.id_type_document} onClick={handleShowModalApprove}>
                                <i className={actionsModule?.approve_production.icon}></i>
                            </Button> : ''}
                            {parseInt(u.anulado) === 2 && actionsModule?.update ? <Button variant={actionsModule?.update.color_action} className="mr-1" size="xs" data-id-document={u.id_document} data-name-document={u.name_document} onClick={handleGet}>
                                <i className={actionsModule?.update.icon}></i>
                            </Button> : ''}
                            {parseInt(u.anulado) !== 1 && parseInt(u.anulado) !== 5 && actionsModule?.ban ? <Button variant={actionsModule?.ban.color_action} className="mr-1" size="xs" data-id-document={u.id_document} data-name-document={u.name_document} onClick={handleShowModalDelete}>
                                <i className={actionsModule?.ban.icon}></i>
                            </Button> : ''}
                            {parseInt(u.anulado) === 6 && actionsModule?.send_branch_office ? <Button variant={actionsModule?.send_branch_office.color_action} size="xs" data-id-document={u.id_document} data-name-document={u.name_document} onClick={handleGet} data-view={1} data-add-details={1}>
                                <i className={actionsModule?.send_branch_office.icon}></i>
                            </Button> : ''}
                            {actionsModule?.free_materia_prima && parseInt(u.anulado) === 2 && parseInt(u.id_type_document) === 6 ? <Button variant={actionsModule.free_materia_prima?.color_action} size="xs" data-id-document={u.id_document} data-name-document={u.name_document} onClick={handleMateriaPrima} data-view={1} data-add-details={1}>
                                <i className={actionsModule.free_materia_prima?.icon}></i>
                            </Button> : ''}
                            {actionsModule?.approve_materia_prima && parseInt(u.anulado) === 8 ? <Button variant={actionsModule?.approve_materia_prima.color_action} className="mr-1" size="xs" data-verified={1} data-view={1} data-id-document={u.id_document} data-id-type-document={u.id_type_document} data-name-document={u.name_document} data-qty-product={u.qty_product} onClick={handleShowModalApprove} data-anulado={parseInt(u.anulado)}>
                                <i className={actionsModule?.approve_materia_prima.icon}></i>
                            </Button> : ''}
                            {actionsModule?.receive_materia_prima && parseInt(u.anulado) === 9 ? <Button variant={actionsModule?.receive_materia_prima.color_action} className="mr-1" size="xs" data-verified={1} data-view={1} data-id-document={u.id_document} data-id-type-document={u.id_type_document} data-name-document={u.name_document} data-qty-product={u.qty_product} onClick={handleShowModalApprove} data-anulado={parseInt(u.anulado)}>
                                <i className={actionsModule?.receive_materia_prima.icon}></i>
                            </Button> : ''}
                        </div>
                    }
                },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
        pageLength={25}
        columnOrder="id_document"
        orderDirection="desc"
    />, [rows, isProcessing])

    const [dataAlert, setDataAlert] = useState({
        icon: '',
        title: '',
        confirmText: '',
        cancelText: '',
        onCancel: _ => { },
        onConfirm: _ => { }
    })

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Listado De {namePlural}</span>
                {actionsModule?.new ? <Button variant={actionsModule?.new.color_action} size="sm" onClick={handleGet}>
                    <i className="fa fa-plus mr-1"></i> {actionsModule?.new.name_action} {nameSingle}
                </Button> : ''}
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false} className="mb-3" onSubmit={_ => {
                    setReload(true)
                }}>
                    <Input
                        classNameParent="col-md-6 col-md-4 mb-2"
                        icon="far fa-calendar"
                        placeholder="Fecha Inicio"
                        text="Fecha Inicio"
                        onChange={e => setDataFilter({ ...dataFilter, p_date_start: e.currentTarget.value })}
                        required
                        type="date"
                        value={dataFilter.p_date_start}
                    />
                    <Input
                        classNameParent="col-md-6 col-md-4 mb-2"
                        icon="far fa-calendar"
                        placeholder="Fecha Fina"
                        text="Fecha Fina"
                        onChange={e => setDataFilter({ ...dataFilter, p_date_end: e.currentTarget.value })}
                        append={[<Button type="submit">
                            <i className="fa fa-search mr-2"></i>Buscar
                        </Button>]}
                        required
                        type="date"
                        value={dataFilter.p_date_end}
                    />
                </FormCustom>
                {dtRows}
            </Card.Body>
        </Card>
        <Modal show={modalShow} onHide={handleHideModalForm} backdrop="static" size="xl">
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DocumentForm submitStatus={_ => {
                    setModalShow(false)
                    setDataUpdated({})
                    setReload(true)
                }} onSubmit={() => { }} setLoadSubmit={setLoadSubmit} setModalShow={setModalShow} setDataUpdated={setDataUpdated} setReload={setReload} loadSubmit={loadSubmit} {...dataUpdated} />
            </Modal.Body>
        </Modal>
        <SweetAlert
            icon={dataAlert.icon}
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea {dataAlert.title}?</>}
            subtitle={<>#{dataDeleted.p_id_document} - {dataDeleted.p_name_document}</>}
            confirmButtonText={dataAlert.confirmText}
            cancelButtonText={dataAlert.cancelText}
            loadSubmit={loadSubmitDelete}
            onCancel={dataAlert.onCancel}
            onConfirm={dataAlert.onConfirm}
            content={dataAlert.content}
        />
    </>
}

export default Document